import { Box, type BoxProps, Grid, Paper, Stack } from "@mui/material";
import { type ReactNode } from "react";

export interface VisitorsHomeTemplateProps {
  activeVisitorsSection: ReactNode;
  chartSlot: ReactNode;
  /** Optional page title row (e.g. `PageHeader`). Omit when the shell already shows context. */
  headerSlot?: ReactNode;
  upcomingVisitorsSection: ReactNode;
  visitorActionsSlot: ReactNode;
  rootSx?: BoxProps["sx"];
}

function SectionSurface({
  children,
  contentSx,
  paperSx,
}: {
  children: ReactNode;
  contentSx?: BoxProps["sx"];
  paperSx?: BoxProps["sx"];
}) {
  return (
    <Paper
      component="section"
      elevation={0}
      sx={[{ borderRadius: 2, overflow: "hidden" }, ...(paperSx ? (Array.isArray(paperSx) ? paperSx : [paperSx]) : [])]}
      variant="outlined"
    >
      <Box sx={[{ p: { sm: 2.5, xs: 2 } }, ...(contentSx ? (Array.isArray(contentSx) ? contentSx : [contentSx]) : [])]}>
        {children}
      </Box>
    </Paper>
  );
}

const chartActiveRowSurfacePaperSx = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  minHeight: 0,
  width: "100%",
} as const;

const chartActiveRowSurfaceContentSx = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  minHeight: 0,
} as const;

export function VisitorsHomeTemplate({
  activeVisitorsSection,
  chartSlot,
  headerSlot,
  upcomingVisitorsSection,
  visitorActionsSlot,
  rootSx,
}: VisitorsHomeTemplateProps) {
  return (
    <Box sx={[{ maxWidth: "100%", overflowX: "hidden" }, ...(Array.isArray(rootSx) ? rootSx : rootSx ? [rootSx] : [])]}>
      <Stack spacing={3} sx={{ width: "100%" }}>
        {headerSlot}
        <SectionSurface>{visitorActionsSlot}</SectionSurface>
        <Grid container spacing={3} sx={{ alignItems: "stretch", width: "100%" }}>
          <Grid size={{ xl: 6, xs: 12 }} sx={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
            <SectionSurface contentSx={chartActiveRowSurfaceContentSx} paperSx={chartActiveRowSurfacePaperSx}>
              {chartSlot}
            </SectionSurface>
          </Grid>
          <Grid size={{ xl: 6, xs: 12 }} sx={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
            <SectionSurface contentSx={chartActiveRowSurfaceContentSx} paperSx={chartActiveRowSurfacePaperSx}>
              {activeVisitorsSection}
            </SectionSurface>
          </Grid>
        </Grid>
        <SectionSurface>{upcomingVisitorsSection}</SectionSurface>
      </Stack>
    </Box>
  );
}
